import { useState, useEffect } from 'react';
import { Image } from '@/components/common/image';
import moments2x from '@/assets/moments-icon/2x/moments.png';
import moments3x from '@/assets/moments-icon/3x/moments.png';

interface MomentsIconProps {
  className?: string;
  width?: number;
  height?: number;
  alt?: string;
}

export function MomentsIcon({
  className,
  alt = "Moments Icon"
}: MomentsIconProps) {
  const [devicePixelRatio, setDevicePixelRatio] = useState(1);

  useEffect(() => {
    // 获取设备像素比
    setDevicePixelRatio(window.devicePixelRatio || 1);

    // 监听设备像素比变化（比如用户缩放页面）
    const handlePixelRatioChange = () => {
      setDevicePixelRatio(window.devicePixelRatio || 1);
    };

    // 使用 matchMedia 监听像素比变化
    const mediaQuery = window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`);
    mediaQuery.addEventListener('change', handlePixelRatioChange);

    return () => {
      mediaQuery.removeEventListener('change', handlePixelRatioChange);
    };
  }, []);

  // 根据设备像素比选择合适的图像（仅保留2x/3x）
  const getImageSrc = () => {
    if (devicePixelRatio >= 2) {
      return moments3x;
    } else {
      return moments2x;
    }
  };

  // 生成 srcSet 用于响应式图像（2x映射1x，3x映射2x）
  const srcSet = `
    ${moments2x} 1x,
    ${moments3x} 2x,
  `;

  return (
    <Image
      src={getImageSrc()}
      srcSet={srcSet}
      alt={alt}
      className={className}
    />
  );
}

export const displayName = "Moments Icon";